import Cookies from 'js-cookie'
import menuCompare from '@/utils/menuCompare';
import store from '@/store'
import md5 from 'js-md5';

const LoginCode = 'logincode'
const PubKey = 'lz-PubKey'
const TokenKey = 'lz-token' 
const CardBlock = 'lz-CardBlock'
const UsedSystem = 'lz-UsedSystem'
const SysPwd = 'lz-SysPwd'
const CardPwdType = 'lz-CardPwdType' 
const OcxVersion = 'lz-OcxVersion'
const Longitude = 'lz-Longitude' // 113.937143;
const Latitude = 'lz-Latitude' // 22.521732;
const EstateName = 'lz-EstateName' 
const EstateId = 'lz-EstateId'  
const LevelId = 'lz-LevelId'
const IsAdmin = 'lz-isadmin'
const FileDomain = 'lz-filedomain'

export function setFileDomain(data) {
  return Cookies.set(FileDomain, data)
} 
export function setIsAdmin(data) {
  return Cookies.set(IsAdmin, data)
}
export function setLevelId(data) {
  return Cookies.set(LevelId, data)
}
export function setEstateName(data) {
  return Cookies.set(EstateName, data)
}
export function setEstateId(data) {
  return Cookies.set(EstateId, data)
}

export function getEstateId() {
  let data = Cookies.get(EstateId)
  return data === undefined || data === '' ? 'undefined' : data;
}
 
export function getFileDomain() { 
  return Cookies.get(FileDomain) 
} 
export function getIsAdmin() { 
  let data = Cookies.get(IsAdmin) 
  return data === 'true' || data === '1' || data === 1
  // return data === undefined || data === '' || data === 'false' || data === 0;
  // return true
}
export function getLevelId() { 
  let data = Cookies.get(LevelId) 
  return data === undefined || data === '' ? 1 : data;
}
export function getEstateName() {
  return Cookies.get(EstateName)
}
export function getOcxVersion() {
  return Cookies.get(OcxVersion)
}
export function getCardPwdType() {
  return Cookies.get(CardPwdType)
}
export function getSysPwd() {
  return Cookies.get(SysPwd)
}

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setLoginCode(logincode) {
  return Cookies.set(LoginCode, logincode)
}

export function getLoginCode() { 
  return Cookies.get(LoginCode)
} 

export function getLatitude() { 
  let data = Cookies.get(Latitude)
  return data === undefined || data === '' ? 22.521732 : data;
}

export function setLatitude(data) {
  return Cookies.set(Latitude, data) 
}

export function getLongitude() {
  let data = Cookies.get(Longitude)
  return data === undefined || data === '' ? 113.937143 : data; 
}

export function setLongitude(data) {
  return Cookies.set(Longitude, data) 
}

export function getCardBlock(systemtypeid) {
  return Cookies.get(CardBlock + systemtypeid)
}
export function setCardBlock(systemtypeid, data) {
  return Cookies.set(CardBlock + systemtypeid, data) 
}
 
export function getUsedSystem() {
  return Cookies.get(UsedSystem) === undefined ? '' : Cookies.get(UsedSystem);
}  

export function setUsedSystem(data) {
  return Cookies.set(UsedSystem, data)
}
export function setOcxVersion(data) {
  return Cookies.set(OcxVersion, data)
}
export function setCardPwdType(data) {
  return Cookies.set(CardPwdType, data)
}

export function setSysPwd(data) {
  return Cookies.set(SysPwd, data)
}  
export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getCookiePubKey() {
  return Cookies.get(PubKey)
}

export function setCookiePubKey(pubkey) {
  return Cookies.set(PubKey, pubkey)
}

export function removeCookiePubKey() {
  return Cookies.remove(PubKey)
}

export function haveMenuRight($btnPath) {
  if (!menuCompare.hasOwnProperty($btnPath)) {
    return false;
  }
  let menuid = -1;
  let obj = menuCompare;
  // (new Function('', 'menuid =obj.' + $btnPath + ';'))();
   eval('menuid =obj.' + $btnPath + ';');
  return store.getters.userRemoteMenuIds.indexOf(menuid) === -1;
}

export function getSign(json, signkey) {
  var res = Object.keys(json).sort();
  let text = [];
  let key = '';
  let value = '';
  let subvalue = ''; 
  for (var i in res) {
    key = res[i];
    value = json[key];  
    if (value == null) {
      continue;
    } 
    if (typeof value === 'object') { 
      subvalue = ''; 
      for (var b in value) {   
        subvalue = value[b];  
        if (subvalue === null || typeof subvalue === 'object') {
          continue;
        }  
        text.push(`${b}=${md5(subvalue.toString()).toString()}`);
      } 
    } else {
      text.push(`${key}=${md5(value.toString()).toString()}`); 
    }  
  } 
  text.push(signkey);  
  return md5(text.join('&')).toString();
}

export function urlencode(clearString) {
  var output = '';
  var x = 0;

  clearString = utf16to8(clearString.toString());
  var regex = /(^[a-zA-Z0-9-_.]*)/;

  while (x < clearString.length) {
    var match = regex.exec(clearString.substr(x));
    if (match != null && match.length > 1 && match[1] !== '') {
      output += match[1];
      x += match[1].length;
    } else {
      if (clearString[x] === ' ') {
        output += '+';
      } else {
        var charCode = clearString.charCodeAt(x);
        var hexVal = charCode.toString(16);
        output += '%' + (hexVal.length < 2 ? '0' : '') + hexVal.toUpperCase();
      }
      x++;
    }
  }

   function utf16to8(str) {
    var out, i, len, c;

    out = '';
    len = str.length;
    for (i = 0; i < len; i++) {
      c = str.charCodeAt(i);
      if ((c >= 0x0001) && (c <= 0x007F)) {
        out += str.charAt(i);
      } else if (c > 0x07FF) {
        out += String.fromCharCode(0xE0 | ((c >> 12) & 0x0F));
        out += String.fromCharCode(0x80 | ((c >> 6) & 0x3F));
        out += String.fromCharCode(0x80 | ((c >> 0) & 0x3F));
      } else {
        out += String.fromCharCode(0xC0 | ((c >> 6) & 0x1F));
        out += String.fromCharCode(0x80 | ((c >> 0) & 0x3F));
      }
    }
    return out;
  }

  return output;
}

export function hasDeviceBrand(brandid) {
  // console.log(brandid)
  for (let i = 0; i < store.getters.brands.length; i++) {
    if (store.getters.brands[i].brandid === brandid) {
      return true;
    }
  }
  return false;
}

export function hasDeviceType(typeid, brandid) {
  let hastype = false 
  let hasbrand = false;
  for (let i = 0; i < store.getters.brands.length; i++) {
    if (store.getters.brands[i].typeid === typeid) {
      hastype = true;
      if (brandid !== undefined && store.getters.brands[i].brandid === brandid) {
        hasbrand = true;
      }
    } 
  }  
  // console.log('typeid:' + typeid + ' hastype:' + hastype + ' brandid:' + brandid + ' hasbrand:' + hasbrand)
  if (brandid !== undefined) {
     return hasbrand;
  } else {
    return hastype;
  }
}



// WEBPACK FOOTER //
// ./src/utils/auth.js